import { Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
import React from 'react';

const CHARGE_BACKGROUND_SHIMMER_PATH = '/assets/images/charge-background-shimmer.svg';

type EmptyTabProps = PropsWithChildren<{
  title: string;
  description?: React.ReactNode;
}>;

export const EmptyTab: React.FC<EmptyTabProps> = ({ children, title, description }) => {
  return (
    <section className="flex w-full justify-center rounded-lg border border-[#E7EEF3] bg-white py-6">
      <div
        className="flex w-full justify-center bg-cover bg-no-repeat pb-10 pt-6"
        style={{ backgroundImage: `url(${CHARGE_BACKGROUND_SHIMMER_PATH})` }}
      >
        <div className="flex max-w-[520px] flex-col gap-y-4 rounded-lg border border-[#E7EEF3] bg-white px-20 py-8 text-center shadow-md">
          <Typography className="text-base font-medium text-black">{title}</Typography>
          <Typography className="text-sm font-normal text-[#576063]">{description}</Typography>
          <div>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};